export const x_app_type = 'x-app-type';
